import { Fetch } from 'lib';
import type { PaymentGateway } from 'types';

type RequestResponses = PaymentGateway;

type RequestParameters = {
  id: string;
};

const getPaymentGateway = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminPaymentGateway/getPaymentGateway',
    params,
  });

export { getPaymentGateway };
